import type { FC } from "react"

interface IconProps {
  fill?: string
  width?: number
  height?: number
  className: string
}

export const Triangle: FC<IconProps> = (props) => (
  <svg
    fill="none"
    height={6}
    viewBox="0 0 8 6"
    width={8}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.49.703C1.2.789 1.905.653 2.613.61c.57-.034 1.134.016 1.704.061.983.08 1.629.126 2.607.005.22-.027.433 0 .647.019.633.007.408.432.294.511-.274.193-.308.422-.51.673-.258.32-.545.58-.846.84-.728.992-1.044 1.264-1.752 2.157-.126.159-.279.291-.416.438-.123.129-.217.109-.311-.044-.185-.301-.868-.613-1.09-.885-.087-.107-.166-.214-.292-.263a.9.9 0 0 1-.524-.579c-.1-.308-.286-.51-.528-.631C.952 2.589.54 2.008.145 1.403.029 1.223-.06 1.037.05.815.158.603.325.65.489.703"
      fill="#252934"
    />
  </svg>
)
